'use client';

import Login from 'src/views/Authentication/Login';

export default function LoginPage() {
  return <Login />;
}
